import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";

/**
 * Why a tracker source needs a clean identifier (PREC-3417).
 *
 * The ticket's core complaint was that users did not understand the requirement and so
 * uploaded files that tracked nothing. Explaining it once, above the form, is the cheap half
 * of the fix — the mapping gate is the other half.
 */
export const TrackerSourceInfoBanner: FunctionComponent = () => {
	const { t } = useTranslation();

	return (
		<div className="mb-6 flex gap-3 rounded-xl border border-border-light bg-blue-action-200 p-4">
			<div className="flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center rounded-lg border border-border-light bg-white text-brand-light">
				<Icon className="h-4 w-4" icon={faCircleInfo} />
			</div>
			<div>
				<h4 className="mb-1 text-sm font-semibold">{t("profileTracker.sources.banner.title")}</h4>
				<p className="max-w-[980px] text-ssm text-text-meta">
					{t("profileTracker.sources.banner.body")}
				</p>
			</div>
		</div>
	);
};
